import { Modal } from '@mantine/core';
import { iconInfo } from 'assets/icons';
import useDevice from 'hooks/useDevice';
import React from 'react';
import { format_curency } from 'utils';

const ConfirmPopup = ({
  isOpen,
  handleClose,
  handleSubmit,
  quantity,
  name,
  point = 1000,
  zIndex = 400,
}) => {
  const isMobile = useDevice().isMobile;

  return (
    <>
      {!isMobile ? (
        <div
          className={`absolute transition-all z-[10000] ${
            isOpen ? 'bottom-0' : '-bottom-16'
          }  flex w-full justify-between items-center bg-[#CFECFF] py-2 px-3`}
        >
          <div className='flex'>
            <img className='w-6 h-6 mr-4' src={iconInfo} alt='' />
            <p className='line-clamp-2'>
              Quý khách có đồng ý đổi <span className="font-bold"> {quantity < 10 ? ('0' + quantity) : quantity}</span> quà tặng <span className="font-bold">{name}</span> với <span className="font-bold">{format_curency(quantity * point)}{' '}
              điểm?</span>
            </p>
          </div>
          <div className='flex'>
            <button
              onClick={handleClose}
              className='uppercase whitespace-nowrap text-black font-averta-semibold text-13px leading-18px bg-white rounded-4px py-3 px-8 ml-6'
            >
              Hủy
            </button>
            <button
              className='uppercase whitespace-nowrap text-white font-averta-semibold text-13px leading-18px bg-gradient-blue rounded-4px py-3 px-8 ml-6'
              onClick={handleSubmit}
            >
              Đồng ý
            </button>
          </div>
        </div>
      ) : (
        <Modal
          radius='md'
          withCloseButton={false}
          opened={isOpen}
          onClose={handleClose}
          centered
          zIndex={zIndex}
          classNames={{
            root: 'pb-9 pt-7 px-10',
            body: 'w-full',
          }}
        >
          <img className='w-12 h-12 mx-auto mb-2' src={iconInfo} alt='' />
          <p className='text-center'>
            Quý khách có đồng ý đổi <span className="font-bold"> {quantity < 10 ? ('0' + quantity) : quantity}</span> quà tặng <span className="font-bold">{name}</span> với <span className="font-bold">{format_curency(quantity * point)}{' '}điểm?</span>
          </p>

          <div className='mt-6 w-fit mx-auto'>
            <button
              onClick={handleClose}
              className='uppercaseb border text-black font-averta-semibold text-13px leading-18px bg-white rounded-4px py-3 px-8'
            >
              Hủy
            </button>
            <button
              className='uppercase text-white font-averta-semibold text-13px leading-18px bg-gradient-blue rounded-4px py-3 px-8 ml-6'
              onClick={handleSubmit}
            >
              Đồng ý
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ConfirmPopup;
